import styled from 'styled-components';

export const UploadItem = styled.div<{
  withName?: boolean;
  isIncorrect?: boolean;
}>`
  position: relative;
  display: flex;
  align-items: center;
  margin-top: 20px;
  padding: 20px;
  cursor: pointer;
  border-radius: 8px;
  transition: ${({ theme }) => theme.transition};
  border: 1px solid
    ${({ theme, withName, isIncorrect }) =>
      isIncorrect
        ? theme.colors.red
        : withName
        ? theme.colors.green
        : theme.colors.darkGrey};
`;

const UploadItemButton = styled.button`
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
  border: 0;
  padding: 8px 16px;
  border-radius: 8px;
  transition: ${({ theme }) => theme.transition};
  cursor: pointer;
`;

export const UploadItemDeleteButton = styled(UploadItemButton)`
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.red};

  &:hover {
    background-color: ${({ theme }) => theme.colors.red};
    color: ${({ theme }) => theme.colors.white};
  }
`;

export const UploadItemRenameButton = styled(UploadItemButton)`
  background-color: ${({ theme }) => theme.colors.purple};
  color: ${({ theme }) => theme.colors.white};

  &:hover {
    opacity: 0.6;
  }
`;

export const UploadItemSection = styled.div<{ column?: boolean }>`
  display: flex;
  justify-content: space-between;
  flex-direction: ${({ column }) => (column ? 'column' : 'row')};

  &:nth-of-type(2) {
    margin-left: 24px;
    margin-right: auto;
  }

  &:last-of-type {
    margin-left: auto;
    align-items: flex-end;
  }
`;

export const UploadItemTitle = styled.p<{
  withName?: boolean;
}>`
  font-size: 16px;
  line-height: 18px;
  font-weight: bold;
  transition: ${({ theme }) => theme.transition};
  color: ${({ theme, withName }) =>
    withName ? theme.colors.white : theme.colors.purple};
  margin-bottom: 4px;
`;

export const UploadItemFileName = styled.p`
  font-size: 14px;
  line-height: 16px;
  transition: ${({ theme }) => theme.transition};
  color: ${({ theme }) => theme.colors.white};
  opacity: 0.5;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

export const IncorrectIndicator = styled.div<{ visible?: boolean }>`
  padding: 4px 8px;
  background-color: ${({ theme }) => theme.colors.red};
  border-radius: 4px;
  font-weight: 500;
  font-size: 11px;
  line-height: 13px;
  color: ${({ theme }) => theme.colors.white};
  position: absolute;
  top: -10px;
  left: 20px;
  transition: ${({ theme }) => theme.transition};
  opacity: ${({ visible }) => (visible ? 1 : 0)};
`;
